import { TaskCreateDto } from '@maia/shared';
import { service } from '@maia/task';
import { CustomerCard, LinkedItem, PageHeader, Typography } from '@maia/ui';
import { getFullName } from '@maia/utils';
import { useMutation } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import * as v from 'valibot';
import { CreateTaskForm } from '../../../../features/task/new/form';
import { getCustomerOptions } from '../../../../features/customer/customer/queryOptions';

export const Route = createFileRoute('/_authenticated/tasks/new/customer')({
  component: Page,
  loaderDeps: ({ search: { guid } }) => ({ guid }),
  loader: ({ context: { queryClient }, deps: { guid } }) =>
    queryClient.ensureQueryData(getCustomerOptions(guid)),
  validateSearch: v.object({
    guid: v.string(),
  }),
});

function Page() {
  const data = Route.useLoaderData();
  const navigate = useNavigate();

  const { mutate } = useMutation({
    mutationFn: (task: Omit<TaskCreateDto, 'linked_item'>) =>
      service.create({
        customerGuid: data.guid,
        ...task,
        linked_item: { guid: data.guid, type: 'customer' },
      }),
    onSuccess: ({ task_guid }) => {
      navigate({ to: `/tasks/${task_guid}` });
    },
  });

  return (
    <div className="layout-sidebar">
      <PageHeader className="area-page-header" title="Taak details invullen" />
      <div className="bg-primary50 p-32">
        <CustomerCard customer={data} />
      </div>
      <CreateTaskForm
        linkedItem={{
          guid: data.guid,
          type: 'customer',
        }}
        onSubmit={async (value) => mutate(value)}
      />
    </div>
  );
}
